import { useEffect, useState } from "react";
import SubmissionForm from "./components/SubmissionForm";
import {
    SubmissionService,
    QueueService,
} from "../../services/SubmissionService";
import * as APIModels from "../../models";
import { useLocation } from "react-router-dom";
import qs from "query-string";

interface QueryParams {
    submissionId?: string;
    attorneyId?: string;
    filter?: string;
    state?: string;
}

export default function File() {
    const s: APIModels.Submission = new APIModels.Submission();
    const [submission, setSubmission] = useState(s);
    const location = useLocation();
    const query = qs.parse(location.search) as QueryParams;

    useEffect(() => {
        if (!submission.id) {
            if (query) {
                console.log("query", query);
                if (query.submissionId) {
                    console.log(
                        "query.submissionId",
                        query.submissionId,
                        query.filter === "preprocess"
                    );
                    QueueService.get({
                        submissionId: query.submissionId || "",
                    }).then(
                        (resp) => {
                            if (resp.successful) {
                                setSubmission(resp.data!);
                            } else {
                                window.location.href = "/queue";
                            }
                        },
                        (error) => {
                            console.log(error);
                            //setError(error);
                        }
                    );
                } else if (query.attorneyId) {
                    console.log(
                        "query.attorneyId",
                        query.attorneyId,
                        query.filter === "preprocess"
                    );
                    QueueService.next({
                        attorneyId: query.attorneyId ?? "",
                        filter: query.filter ?? "",
                        state: query.state ?? "",
                    }).then(
                        (resp) => {
                            if (resp.successful) {
                                setSubmission(resp.data!);
                            } else {
                                window.location.href = "/queue";
                            }
                        },
                        (error) => {
                            console.log(error);
                            //setError(error);
                        }
                    );
                }
            } else {
                window.location.href = "/queue";
            }
        }
    }, [query]);

    const nextSubmission = (next: APIModels.Submission) => setSubmission(next);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">File</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">eFile</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        File
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <SubmissionForm
                    submission={submission}
                    setNextSubmission={nextSubmission}
                    filter={query.filter}
                />
            </div>
        </div>
    );
}
